import React from "react";
import { classnames, Loader } from "@culturehq/components";
import { Trans } from "app/utils";
import { CurrentOption } from "./EffectsSDKCameraRecorder";

interface CameraPreviewProps {
  effectsIsReady: boolean;
  hasCamera: boolean;
  onSetCurrentOption: (option: CurrentOption) => void;
  recordEffects: boolean;
  showCountdown: boolean;
  videoRef: React.RefObject<HTMLVideoElement>;
}

const CameraPreview: React.FC<CameraPreviewProps> = ({
  effectsIsReady,
  hasCamera,
  onSetCurrentOption,
  recordEffects,
  showCountdown,
  videoRef
}) => {
  if (!hasCamera) {
    return (
      <div style={{ height: "400px", alignContent: "center", textAlign: "center" }}>
        <h1><Trans>It looks like your camera is missing.</Trans></h1>
        <h1><Trans>You can record your screen instead.</Trans></h1>
      </div>
    );
  }

  if (!recordEffects) {
    return (
      <div className="Video-Preview__Source">
        <video
          muted
          className={classnames("Video-Preview__Source-Video", { "Video-Preview__Source-Video__filtered": showCountdown })}
          ref={videoRef}
          width={1080}
          autoPlay
          onClick={() => { onSetCurrentOption("none"); }}
        />
        {!effectsIsReady && (
          <div className="Video-Preview__Source-Overlay">
            <Loader loading />
          </div>
        )}
      </div>
    );
  }

  return <></>;
};

export default CameraPreview;
